import { render, staticRenderFns } from "./reports_screen.vue?vue&type=template&id=958961dc&"
import script from "./reports_screen.vue?vue&type=script&lang=js&"
export * from "./reports_screen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('958961dc')) {
      api.createRecord('958961dc', component.options)
    } else {
      api.reload('958961dc', component.options)
    }
    module.hot.accept("./reports_screen.vue?vue&type=template&id=958961dc&", function () {
      api.rerender('958961dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/reports/reports_screen.vue"
export default component.exports